import {i18n} from 'i18next';
import en from './translations.en';

const add = (i18next: i18n) => {
  i18next.addResourceBundle('en-US', 'styleguide', en);
};

export default add;
